/**
 * Custom Wishlist Logic
 * Uses localStorage to save product handles.
 */
class CustomWishlist {
  constructor() {
    this.storageKey = 'custom_wishlist';
    this.wishlist = this.getWishlist();
    this.initButtons();
    this.updateCounts();
  }

  getWishlist() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : [];
  }

  saveWishlist(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
    this.wishlist = list;
    this.updateButtons();
    this.updateCounts();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: this.wishlist }));
  }

  toggle(handle) {
    let list = this.getWishlist();
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
    } else {
      list.push(handle);
    }
    this.saveWishlist(list);
  }

  initButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-btn]');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.getAttribute('data-product-handle');
      if (handle) {
        this.toggle(handle);
      }
    });
    this.updateButtons();
  }

  updateButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const textEl = btn.querySelector('.wishlist-text');
      const icon = btn.querySelector('svg');
      if (this.wishlist.includes(handle)) {
        btn.classList.add('is-active');
        if (textEl) textEl.textContent = 'Remove from wishlist';
        if (icon) icon.setAttribute('fill', 'currentColor');
      } else {
        btn.classList.remove('is-active');
        if (textEl) textEl.textContent = 'Add to wishlist';
        if (icon) icon.setAttribute('fill', 'none');
      }
    });
  }

  updateCounts() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      if (this.wishlist.length > 0) {
        el.textContent = this.wishlist.length;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.customWishlist = new CustomWishlist();
});
